import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const slug = 'overhead-and-underground-service-lines';
const serviceId = 3
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Overhead & Underground Service Lines",
        description: "Installing, upgrading, or repairing overhead and underground power lines for safe and reliable electricity supply.",
        keywords: "overhead service lines Sydney, underground service lines Sydney, power line installation, power line repair Sydney, licensed electricians Sydney, electrical service upgrade, safe power line services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Overhead & Underground Service Lines',
    description: 'Installing, upgrading, or repairing overhead and underground power lines for safe and reliable electricity supply.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
